@import 'src/styles/palette';

.headerChildren {
  margin: auto;
  width: 100%; // Change (e.g. back to 95%), if the discussion about section padding resurfaces
}

.agreementContent {
  & > section:last-child {
    margin-bottom: 1rem;
  }
}

.utkastColor {
  color: _palette(text-primary);
  background-color: _palette(period-border-weak);
}

.feilColor {
  color: _palette(text-primary);
  background-color: _palette(text-red);
}
